import c from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { CheckmarkFill, PlusFill } from '@lyearn/icons';
import { Box, Checkbox, LinkButton, Stack, Tooltip, Typography } from '@lyearn/ui';
import stopPropagation from '@/consts/stopPropogation';

import useCategoryPermissions from '../../../hooks/useCategoryPermissions';
import { CategoryLayoutView } from '../../../types';
import { addButtonStyles } from './styles';

const CategoryFooter = ({
  fetchingOnCreate,
  isChecked,
  contentCount,
  layoutView,
  onToggleSelection,
  onAdd,
}: {
  fetchingOnCreate?: boolean;
  isChecked: boolean;
  contentCount: number;
  layoutView: CategoryLayoutView;
  onToggleSelection: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onAdd: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}) => {
  const { t } = useTranslation();
  const { permissions } = useCategoryPermissions();

  const renderLabel = () => {
    if (['edit', 'single-select'].includes(layoutView)) {
      return (
        <Typography color="text-text-secondary" variant="body-short-02">
          {t('Discover:Category.Admin.ContentCount', { contentCount })}
        </Typography>
      );
    }
  };

  const renderAction = () => {
    if (layoutView === 'multi-select') {
      return <Checkbox checked={isChecked} className="h-20 w-20" onClick={onToggleSelection} />;
    }

    if (layoutView === 'single-select') {
      return (
        <CheckmarkFill
          className={c('h-20 w-20 opacity-0', { 'opacity-100': isChecked })}
          fillColorToken="icon-active"
        />
      );
    }

    if (layoutView === 'edit') {
      if (!permissions.canCreate) return null;
      return (
        <Tooltip title={t('Discover:Category.Admin.AddASubcategory')}>
          <Box onClick={stopPropagation}>
            <LinkButton
              Icon={PlusFill}
              className={c('h-20 w-20 !opacity-0 group-hover:!opacity-100', addButtonStyles)}
              color="internal"
              disabled={fetchingOnCreate}
              onClick={onAdd}
            />
          </Box>
        </Tooltip>
      );
    }

    return null;
  };

  return (
    <Stack alignItems="center" className="flex-shrink-0 ms-16" gapX={16}>
      {renderLabel()}
      {renderAction()}
    </Stack>
  );
};

export default CategoryFooter;
